<mat-dialog-content class="site-search-content">
    <div class="site-search-switch">
        <div id="search-term">
            <span> Search Results For: {{ data.search }} </span>
        </div>
    </div>

    <kendo-grid
        #grid="kendoGrid"
        class="lg-kendo-grid"
        [loading]="loading"
        [data]="gridView"
        [pageSize]="state.take"
        [skip]="state.skip"
        [sort]="state.sort"
        [group]="state.group"
        [groupable]="true"
        [sortable]="true"
        [pageable]="pageable"
        [scrollable]="'scrollable'"
        [resizable]="true"
        [height]="650"
        (dataStateChange)="dataStateChange($event)"
    >
        <kendo-grid-column field="rowType" title="Type" [autoSize]="true" [hidden]="true">
            <ng-template
                kendoGridGroupHeaderTemplate
                let-group
                let-field="rowType"
                let-value="value"
            >
                <div *ngIf="value === 'L'">
                    <span>
                        Loans
                    </span>
                </div>
                <div *ngIf="value === 'E'">
                    <span>
                        Employees
                    </span>
                </div>
                <div *ngIf="value === 'H'">
                    <span>
                        Entities
                    </span>
                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="identifier" title="Identifier" format="{0:c}">
            <ng-template kendoGridCellTemplate let-record>
                <div>
                    <a (click)="cellClickHandler(record)" class="hyperlink-name">
                        {{ record.identifier }}</a
                    >
                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="name" title="Name"> </kendo-grid-column>

        <kendo-grid-column field="description" title="Description"> </kendo-grid-column>
    </kendo-grid>
</mat-dialog-content>
